import React, { useState } from "react";
import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { routes } from "consts";
import { PaziaButton, PaziaLinkButton, PaziaLoader } from "components/atoms";
import { useCourse } from "api/hooks";
import { useParams } from "react-router-dom";
import { BalancePieChart } from "./BalancePieChart";
import { CourseFinancesTable } from "./CourseFinancesTable";
import { RemovedStudentsRevenue } from "./RemovedStudentsRevenue";
import { TrainerCostsSection } from "pages/CourseCreate/Schedule/trainer-costs/TrainerCostsSection";
import { CreateCourseFinanceModal } from "pages/CourseManage/CreateCourseFinanceModal/CreateCourseFinanceModal";
import { CreateCourseFinanseRequest, courseFinancesApi } from "api/course-finances";
import { queryClient } from "main";
import { QUERIES_KEYS } from "queries";
import { useToaster } from "utils";
// import Fin2 from "./FintechCard09";

export const CourseFinancesPage = () => {
  const { courseId } = useParams();
  const { loading: loadingCourse, data: course } = useCourse(Number(courseId));
  const { showSuccess, showError } = useToaster();
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const onCreate = async (data: CreateCourseFinanseRequest) => {
    try {
      await courseFinancesApi.create(Number(courseId), data);
      setIsCreateOpen(false);
      showSuccess("Dodano płatność");
      [
        QUERIES_KEYS.COURSE_FINANCES,
        QUERIES_KEYS.COURSE_FINANCES_BY_CATEGORIES,
        QUERIES_KEYS.COURSE_FINANCES_RECONCILIATION,
      ].forEach((key) => queryClient.invalidateQueries({ queryKey: key(Number(courseId)) }));
    } catch (e) {
      showError("Wystąpił błąd podczas dodawania płatności");
      console.error(e);
    }
  };

  if (loadingCourse) return <PaziaLoader position="center" />;
  if (!course) return null;
  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[
          { title: "Kursy", path: routes.COURSES },
          {
            title: [course.data.name, course.data.variant].filter(Boolean).join(" · "),
            path: routes.COURSES_MANAGE(course.data.id),
          },
          { title: "Zestawienie finansowe" },
        ]}
        headerText="Zestawienie finansowe"
        headerButton={
          <div className="flex gap-2">
            <PaziaLinkButton type="secondary" href={routes.COURSES_MANAGE_NESTED.RECONCILIATION(course.data.id)}>
              Rozliczenie
            </PaziaLinkButton>
            <PaziaButton type="primary" title="Dodaj płatność +" onClick={() => setIsCreateOpen(true)} />
          </div>
        }
      />
      <div className="grid grid-cols-12 gap-6">
        <BalancePieChart courseId={Number(courseId)} className="col-span-12 lg:col-span-4" />
        <div className="col-span-12">
          <CourseFinancesTable courseId={Number(courseId)} />
        </div>
        <div className="col-span-12">
          <RemovedStudentsRevenue courseId={Number(courseId)} />
        </div>
        <TrainerCostsSection courseId={Number(courseId)} className="col-span-12" />
      </div>
      <CreateCourseFinanceModal
        isOpen={isCreateOpen}
        onCloseRequest={() => setIsCreateOpen(false)}
        onSubmit={onCreate}
        courseId={Number(courseId)}
      />
      {/* <CourseFinancesFilters groupId={Number(groupId)} courseIds={courseIds} onCourseChange={onCourseChange} /> */}
    </PageMain>
  );
};
